import React from 'react';
import { InfoCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { ROUTING_AVAILABILITY_DISCLAIMER } from '@utils/constants';
import './RoutingDisclaimer.css';

interface RoutingDisclaimerProps {
  /** 'full' shows title + bullet points; 'compact' shows a condensed single-line version */
  variant?: 'full' | 'compact';
  className?: string;
}

export const RoutingDisclaimer: React.FC<RoutingDisclaimerProps> = ({
  variant = 'full',
  className = '',
}) => {
  if (variant === 'compact') {
    return (
      <div className={`routing-disclaimer routing-disclaimer--compact ${className}`}>
        <InfoCircleOutlined className="routing-disclaimer__icon" />
        <p className="routing-disclaimer__text">{ROUTING_AVAILABILITY_DISCLAIMER.flat}</p>
      </div>
    );
  }

  return (
    <div className={`routing-disclaimer ${className}`} role="status">
      <div className="routing-disclaimer__header">
        <ClockCircleOutlined className="routing-disclaimer__header-icon" />
        <span className="routing-disclaimer__title">{ROUTING_AVAILABILITY_DISCLAIMER.title}</span>
      </div>
      <ul className="routing-disclaimer__list">
        {ROUTING_AVAILABILITY_DISCLAIMER.points.map((point, i) => (
          <li key={i} className="routing-disclaimer__item">{point}</li>
        ))}
      </ul>
    </div>
  );
};
